let callback = null

const icons = {
    success: "mdi-check-circle",
    error: "mdi-alert-circle",
    info: "mdi-information",
    warning: "mdi-alert",
}

export default {
    setCallback(fn) {
        callback = fn
    },
    success(message) {
        if (callback) callback("success", message, icons.success)
    },
    error(message) {
        if (callback) callback("error", message, icons.error)
    },
    info(message) {
        if (callback) callback("info", message, icons.info)
    },
    warning(message) {
        if (callback) callback("warning", message, icons.warning)
    },
}
